import { useCallback } from 'react'
import { giveGenericHandleChangedData } from 'src/consumer/helpers/utilFunctions'

/**
 * Hook for handling patient info section settings
 * Manages boolean toggles and nested TemplateTextProperties
 */
export default function usePatientInfoHandlers(setPrescriptionTemplate) {
  // Handler for boolean fields (showQRCode, showPatientAddress, etc.)
  const handlePatientInfoBooleanChange = useCallback(
    (e) => {
      setPrescriptionTemplate((prev) => ({
        ...prev,
        patientInfoSectionSettings: {
          ...(prev?.patientInfoSectionSettings || {}),
          [e.target.id]: e.target.checked,
        },
      }))
    },
    [setPrescriptionTemplate],
  )

  // Handler for nested TextProperties (e.g., patientNameKey, patientNameVal)
  const handlePatientInfoTextPropertyChange = useCallback(
    (fieldId, eventOrUpdater) => {
      setPrescriptionTemplate((prev) => {
        const currentSettings = prev?.patientInfoSectionSettings || {}
        const currentFieldData = currentSettings[fieldId] || {}

        return {
          ...prev,
          patientInfoSectionSettings: {
            ...currentSettings,
            [fieldId]: giveGenericHandleChangedData(eventOrUpdater, currentFieldData),
          },
        }
      })
    },
    [setPrescriptionTemplate],
  )

  // Factory for creating scoped setters for specific text property fields
  const createTextPropertySetter = useCallback(
    (fieldId) => {
      return (eventOrUpdater) => {
        handlePatientInfoTextPropertyChange(fieldId, eventOrUpdater)
      }
    },
    [handlePatientInfoTextPropertyChange],
  )

  return {
    handlePatientInfoBooleanChange,
    handlePatientInfoTextPropertyChange,
    createTextPropertySetter,
  }
}
